import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";

export const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-base font-bold text-slate-100">{title}</h2>
    <div className="text-sm text-slate-300 leading-relaxed space-y-1">{children}</div>
  </section>
);

const LegalNav = () => (
  <nav className="pt-5 mt-2 border-t border-slate-800 flex flex-wrap gap-x-4 gap-y-1 text-xs">
    <Link to="/mentions-legales" className="text-sky-400 hover:underline">Mentions légales</Link>
    <Link to="/cgu" className="text-sky-400 hover:underline">Conditions d'utilisation</Link>
    <Link to="/confidentialite" className="text-sky-400 hover:underline">Confidentialité</Link>
    <Link to="/cookies" className="text-sky-400 hover:underline">Cookies</Link>
  </nav>
);

export const LegalLayout = ({ title, testid, intro, children }) => (
  <div className="min-h-screen bg-[#0B0F17] text-slate-100 flex flex-col">
    <header className="bg-[#0B0F17]/95 border-b border-slate-800 sticky top-0 z-10 px-4 py-3 flex items-center gap-3">
      <Link to="/" data-testid="legal-back" className="h-10 w-10 flex items-center justify-center rounded-lg bg-slate-800 hover:bg-slate-700"><ArrowLeft size={18} /></Link>
      <h1 className="font-black tracking-tight text-lg">{title}</h1>
    </header>
    <div data-testid={testid} className="flex-1 max-w-2xl mx-auto px-4 py-6 space-y-6">
      {intro && <p className="text-xs text-slate-500">{intro}</p>}
      {children}
      <LegalNav />
    </div>
    <Footer />
  </div>
);
